import API from "../../Api/Api";
import { API_END_POINT } from "../../Api/EndPoints";
import qs from "qs";
import store from "../store";

export const getOrganizations =
  (extraFilters = {}, signal) =>
  async (dispatch) => {
    const { user } = store.getState().userReducer;
    const userMarqueId = user?.attributes?.marque?.data?.id;
    dispatch({ type: "FETCH_ORGANIZATIONS_LOADING" });
    try {
      const queryString = qs.stringify({
        populate: {
          business_affiliate: true,
          marque: true,
        },
        filters: {
          marque: { id: { $eq: userMarqueId } },
          $or: [
            {
              archived: { $eq: false },
            },
            {
              archived: { $null: true },
            },
          ],
          ...extraFilters,
        },
      });
      const { data } = await API.get(
        `${API_END_POINT}api/organizations?${queryString}`,
        { signal },
      );

      const payload = data?.data
        ?.filter((item) => {
          return (
            item?.attributes?.archived === false ||
            item?.attributes?.archived === null
          );
        })
        ?.map((item) => {
          return {
            name: item?.attributes?.name,
            code: item?.id,
            businessAffiliate: item?.attributes?.business_affiliate?.data?.id,
          };
        });
      dispatch({ type: "FETCH_ORGANIZATIONS_SUCCESS", payload });
    } catch (error) {
      if (error.name === "CanceledError" || error.code === "ERR_CANCELED")
        return;
      dispatch({ type: "FETCH_ORGANIZATIONS_ERROR" });
    }
  };
